module.exports = __webpack_public_path__ + "static/media/efficency_circle.7a2ea75f.svg";